import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tz/go/egaz/osci/ptl/comn";

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/btch/info`,
    api_infos: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/btch/info`,
    api_excutn: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/btch/excutn`,
    nodes: [],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    osci0112001q: `${BASE.path}/osci0112001q`, // Manage batch information list !== 배치정보관리 목록 ==!
    osci0112002s: `${BASE.path}/osci0112002s`, // Manage batch information registration !== 배치정보관리 등록 ==!
    osci0112003s: `${BASE.path}/osci0112003s`, // Manage batch information Modifying !== 배치정보관리 수정 ==!
    osci0112004q: `${BASE.path}/osci0112004q`, // Manage batch information details !== 배치정보관리 상세 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // Get a list of batch information. !== 배치정보 목록을 조회한다. ==!
    getBtchInfoList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api_infos}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Select batch details !== 배치 상세 정보 조회 ==!
    getBtchInfo: (btchId: any) => {
        return api.get(`${BASE.api_infos}/${btchId}`);
    },
    // Create batch information !== 배치 정보 생성 ==!
    createBtchInfo: (data: any) => {
        return api.post(`${BASE.api_infos}`, {
            ...data,
        });
    },
    // Update batch information !== 배치 정보 수정 ==!
    updateBtchInfo: (data: any) => {
        return api.put(`${BASE.api_infos}/${data.btchId}`, {
            ...data,
        });
    },
    // Delete batch information !== 배치 정보 삭제 ==!
    deleteBtchInfo: (btchId: any) => {
        return api.delete(`${BASE.api_infos}/${btchId}`);
    },
    // Pause batch !== 배치 중지 ==!
    pauseBtch: (data: any) => {
        return api.post(`${BASE.api_excutn}/pause`, {
            ...data,
        });
    },
    // Resume batch !== 배치 재실행 ==!
    resumeBtch: (data: any) => {
        return api.post(`${BASE.api_excutn}/resume`, {
            ...data,
        });
    },
};

export const SF_BTCH_INFO_SEARCH_FORM: TFormSchema = {
    id: "form_infoSrch",
    schema: {
        /* Business Type !== 업무분류 ==!*/
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_NM",
            all: true,
            area: "comnCd",
            comnCd: "OSC0088",
        },
        /* Search keyword Select Option !== 검색어 목록 ==!*/
        kwdSel: {
            type: "select",
            label: "L_KWD",
            options: [
                { label: "L_BTCH_NM", value: "A" },
                { label: "L_BTCH_DESC", value: "B" },
            ],
        },
        /* Search keyword Select Option Name !== 검색어 ==!*/
        kwdTxt: {
            type: "text",
            readOnly: true,
        },
    },
};

export const SF_BTCH_INFO_FORM: TFormSchema = {
    id: "form_infoSrch",
    schema: {
        btchId: {
            type: "text",
            label: "L_BTCH_ID",
            edit: true,
        } /* Batch ID !== 배치 ID ==!*/,
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_NM",
            edit: true,
            required: true,
            area: "comnCd",
            comnCd: "OSC0088",
            defaultValue: "OSC",
        } /* Business Type !== 업무분류 ==!*/,
        btchNm: {
            type: "text",
            label: "L_BTCH_NM",
            edit: true,
            required: true,
            maxLength: 200,
        } /* Job Name(Barch Name) !== Job 이름(배치명) ==!*/,
        btchDesc: {
            type: "textarea",
            label: "L_BTCH_DESC",
            edit: true,
            required: true,
            maxLength: 2000,
        } /* Batch Description !== 배치설명 ==!*/,
        onlnExcutnPsblYn: {
            type: "select",
            label: "L_ONLN_EXCUTN_YN",
            edit: true,
            required: true,
        } /* Online Execution Yn !== 온라인 실행여부 ==!*/,
        frstRgsrDtm: {
            type: "datetime",
            label: "L_FRST_RGSR_DTM",
            edit: true,
        } /* Registration Date !== 등록 일자 ==!*/,
        lastMdfyDtm: {
            type: "datetime",
            label: "L_LAST_MDFY_DTM",
            edit: true,
        } /* Last Modify Date !== 최종 수정 일자 ==!*/,
    },
};

export const SG_BTCH_INFO_LIST: TGridSchema = {
    id: "grid_btchInfoList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_BTCH_ID", binding: "btchId", width: "20%" }], id: "btchId" },
        { cells: [{ header: "L_BSOP_CLSF_NM", binding: "bsopClsfCdNm", width: "10%" }], id: "bsopClsfCd" },
        { cells: [{ header: "L_BTCH_NM", binding: "btchNm", width: "20%" }], id: "btchNm" },
        { cells: [{ header: "L_DESC", binding: "btchDesc", width: "*" }], id: "btchDesc" },
        { cells: [{ header: "L_ONLN_EXCUTN_YN", binding: "onlnExcutnPsblYn", width: "10%" }], id: "onlnExcutnPsblYn" },
    ],
    body: [
        {
            cells: [{ binding: "btchId" }] /* Batch ID !== 배치 ID ==!*/,
        },
        {
            cells: [{ binding: "bsopClsfCdNm" }] /* Business Type !== 업무분류 ==!*/,
        },
        {
            cells: [{ binding: "btchNm", align: "left" }] /* Job Name(Barch Name) !== Job 이름(배치명) ==!*/,
        },
        {
            cells: [{ binding: "btchDesc", align: "left" }] /* Batch Description !== 배치설명 ==!*/,
        },
        {
            cells: [{ binding: "onlnExcutnPsblYn" }] /* Online Execution Yn !== 온라인 실행여부 ==!*/,
        },
    ],
};

export const SG_BTCH_INFO_PRMT_LIST: TGridSchema = {
    id: "grid_btchInfoPrmtList",
    options: { edit: false, checkbox: true, radio: false, index: false },
    head: [{ cells: [{ header: "L_PRMT_NM", binding: "btchPrmtNm", width: "*" }], id: "btchPrmtNm" }],
    body: [
        {
            cells: [{ binding: "btchPrmtNm", align: "left" }] /* Parameter Name !== 파라미터명 ==!*/,
        },
    ],
};

export const SG_BTCH_INFO_SCHD_LIST: TGridSchema = {
    id: "grid_btchInfoSchdList",
    options: { edit: false, checkbox: false, radio: false, index: true },
    head: [
        { cells: [{ header: "L_BTCH_SCHD_ID", binding: "btchSchdId", width: "*" }], id: "btchSchdId" },
        { cells: [{ header: "L_BTCH_SCHD_NM", binding: "btchSchdNm", width: "*" }], id: "btchSchdNm" },
        { cells: [{ header: "L_EXCUTN_CYCLE", binding: "btchSchdCnxsValue", width: "*" }], id: "btchSchdCnxsValue" },
    ],
    body: [
        {
            cells: [{ binding: "btchSchdId" }] /* Schedules Number !== 스케줄번호 ==!*/,
        },
        {
            cells: [{ binding: "btchSchdNm", align: "left" }] /* Schedules Name !== 스케줄명 ==!*/,
        },
        {
            cells: [{ binding: "btchSchdCnxsValue", align: "left" }] /* Execution Cycle !== 실행주기 ==!*/,
        },
    ],
};
